import { OnBack, StepProps } from '~shared/components/reactHookForm/MultiStepForm/useMultiStepForm'
import { Step3SummaryForm } from '~app/screens/SpareAxleRequest/components/screens/step3/Step3SummaryForm'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { SubmitHandler } from 'react-hook-form'
import {
  updateFormStepValues, updateFormStepValuesAndSubmit,
} from '~store/wizardSpareAxleRequest/actions'
import { Step3SummarySchema } from '~app/screens/SpareAxleRequest/components/screens/step3/Step3Summary.schema'
import Step3Summary from '~app/screens/SpareAxleRequest/components/screens/step3/Step3Summary'

type Step3Hook = () => StepProps<Step3SummaryForm>

export const useStep3: Step3Hook = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onSubmit: SubmitHandler<Step3SummaryForm> = (formValues):void => {
    dispatch(updateFormStepValuesAndSubmit({ step: 'step3', values: formValues }))
  }
  const onBack: OnBack<Step3SummaryForm> = (formValues) => {
    dispatch(updateFormStepValues({ step: 'step3', values: formValues }))
  }

  return {
    onSubmit,
    onBack,
    component: Step3Summary,
    validationSchema: Step3SummarySchema,
    label: t('form:spareAxleRequestFormStep3Label'),
  }
}
